import keyMirror from "ramda-extension/es/keyMirror";
export const actionTypes = keyMirror({
    SET_REQUEST_STATUS: null,
    CLEAR_REQUEST_STATUS: null,
    RESET: null
});
export const requestStates = keyMirror({
    REQUESTED: null,
    IN_QUEUE: null,
    COMPLETED: null,
    CANCELED: null,
    IN_PROGRESS: null,
    ERROR: null,
    PAUSED: null
});
export const REDUCER_NAME = 'status';
export default {
    actionTypes,
    requestStates,
    REDUCER_NAME
};
